var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeApplying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "research_1_",
    "data-name": "research (1)",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55571",
    "data-name": "Path 55571",
    d: "M25.352,85.125H2.148A2.148,2.148,0,0,1,0,82.977V50.148A2.148,2.148,0,0,1,2.148,48h23.2A2.148,2.148,0,0,1,27.5,50.148V82.977A2.148,2.148,0,0,1,25.352,85.125Z",
    transform: "translate(0 -43.875)",
    fill: "#fd6930"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55572",
    "data-name": "Path 55572",
    d: "M53.57,111.625H32.43a.43.43,0,0,1-.43-.43V80.43a.43.43,0,0,1,.43-.43H53.57a.43.43,0,0,1,.43.43V111.2A.43.43,0,0,1,53.57,111.625Z",
    transform: "translate(-29.25 -73.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48225",
    "data-name": "Group 48225",
    transform: "translate(10.355 11.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55573",
    "data-name": "Path 55573",
    d: "M128.444,137.789h-7.3a.645.645,0,0,1,0-1.289h7.3a.645.645,0,0,1,0,1.289Z",
    transform: "translate(-120.501 -136.5)",
    fill: "#0055a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55574",
    "data-name": "Path 55574",
    d: "M128.191,169.789h-7.047a.645.645,0,1,1,0-1.289h7.047a.645.645,0,1,1,0,1.289Z",
    transform: "translate(-120.5 -165.75)",
    fill: "#0055a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55575",
    "data-name": "Path 55575",
    d: "M128.441,201.789h-7.3a.645.645,0,0,1,0-1.289h7.3a.645.645,0,0,1,0,1.289Z",
    transform: "translate(-120.5 -195)",
    fill: "#0055a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55576",
    "data-name": "Path 55576",
    d: "M129.223,233.789h-8.078a.645.645,0,0,1,0-1.289h8.078a.645.645,0,0,1,0,1.289Z",
    transform: "translate(-120.501 -224.25)",
    fill: "#0055a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55577",
    "data-name": "Path 55577",
    d: "M130.272,265.789h-9.126a.645.645,0,1,1,0-1.289h9.126a.645.645,0,1,1,0,1.289Z",
    transform: "translate(-120.501 -253.5)",
    fill: "#0055a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55578",
    "data-name": "Path 55578",
    d: "M128.427,297.789h-7.283a.645.645,0,0,1,0-1.289h7.283a.645.645,0,0,1,0,1.289Z",
    transform: "translate(-120.5 -282.75)",
    fill: "#0055a3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55579",
    "data-name": "Path 55579",
    d: "M90.018,2.75a.424.424,0,0,1-.418-.373,2.75,2.75,0,0,0-5.45,0,.424.424,0,0,1-.418.373H80.859A.859.859,0,0,0,80,3.609V8.25a1.328,1.328,0,0,0,1.328,1.328H92.422A1.328,1.328,0,0,0,93.75,8.25V3.609a.859.859,0,0,0-.859-.859Z",
    transform: "translate(-73.125)",
    fill: "#528fd8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48227",
    "data-name": "Group 48227",
    transform: "translate(8.98 6.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48226",
    "data-name": "Group 48226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55580",
    "data-name": "Path 55580",
    d: "M116.145,73.789h-11a.645.645,0,0,1,0-1.289h11a.645.645,0,0,1,0,1.289Z",
    transform: "translate(-104.5 -72.5)",
    fill: "#0573ce"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_55581",
    "data-name": "Path 55581",
    d: "M175.211,0a15.13,15.13,0,0,0-13.4,22.309,2.214,2.214,0,0,1-.38,2.619l-1.314,1.314,1.257,2.632,2.632,1.257,1.314-1.314a2.214,2.214,0,0,1,2.619-.38A15.126,15.126,0,1,0,175.211,0Z",
    transform: "translate(-146.251 0)",
    fill: "#b2caec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55582",
    "data-name": "Path 55582",
    d: "M199.984,23.771a15.132,15.132,0,0,0-10.2-14.218A15.127,15.127,0,0,1,174.133,35.4a2.214,2.214,0,0,0-2.619.38l-.865.865.46.963,2.632,1.257,1.314-1.314a2.214,2.214,0,0,1,2.619-.38,15.13,15.13,0,0,0,22.309-13.4Z",
    transform: "translate(-155.984 -8.732)",
    fill: "#82aee3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2835",
    "data-name": "Ellipse 2835",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(17.999 4)",
    fill: "#f2fbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55583",
    "data-name": "Path 55583",
    d: "M322.289,48a11.122,11.122,0,0,0-1.289.075,11,11,0,0,1,0,21.85,11.123,11.123,0,0,0,1.289.075,11,11,0,1,0,0-22Z",
    transform: "translate(-293.415 -43.875)",
    fill: "#dff6fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55584",
    "data-name": "Path 55584",
    d: "M255.289,113.676l-1.352-1.352a1.107,1.107,0,0,0-1.565,0l-6.023,6.023-3.107-3.107a1.107,1.107,0,0,0-1.565,0l-1.352,1.352a1.107,1.107,0,0,0,0,1.565l5.241,5.241a1.107,1.107,0,0,0,1.565,0l8.158-8.158A1.107,1.107,0,0,0,255.289,113.676Z",
    transform: "translate(-219.377 -102.375)",
    fill: "#80d261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55585",
    "data-name": "Path 55585",
    d: "M16.883,311.882l.873-2.619-3.889-3.889-2.619.873a1.329,1.329,0,0,0-.519.321L.648,316.648a2.213,2.213,0,0,0,0,3.13l2.7,2.7a2.213,2.213,0,0,0,3.13,0L16.563,312.4a1.325,1.325,0,0,0,.321-.519Z",
    transform: "translate(0 -279.13)",
    fill: "#01c0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55586",
    "data-name": "Path 55586",
    d: "M28.808,319.722,15,333.534l2.063,2.063a2.213,2.213,0,0,0,3.13,0L30.27,325.516a1.328,1.328,0,0,0,.321-.519l.873-2.619Z",
    transform: "translate(-13.708 -292.246)",
    fill: "#08a9f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55587",
    "data-name": "Path 55587",
    d: "M66.32,146.75H64.43a.43.43,0,0,1-.43-.43V144.43a.43.43,0,0,1,.43-.43H66.32a.43.43,0,0,1,.43.43v1.891A.43.43,0,0,1,66.32,146.75Z",
    transform: "translate(-58.5 -131.625)",
    fill: "#01c0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55588",
    "data-name": "Path 55588",
    d: "M66.32,210.75H64.43a.43.43,0,0,1-.43-.43V208.43a.43.43,0,0,1,.43-.43H66.32a.43.43,0,0,1,.43.43v1.891A.43.43,0,0,1,66.32,210.75Z",
    transform: "translate(-58.5 -190.125)",
    fill: "#01c0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55589",
    "data-name": "Path 55589",
    d: "M66.32,274.75H64.43a.43.43,0,0,1-.43-.43V272.43a.43.43,0,0,1,.43-.43H66.32a.43.43,0,0,1,.43.43v1.891A.43.43,0,0,1,66.32,274.75Z",
    transform: "translate(-58.5 -248.625)",
    fill: "#01c0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55590",
    "data-name": "Path 55590",
    d: "M206.133,286.777a.643.643,0,0,1-.456-.189l-.617-.617a.645.645,0,1,1,.912-.911l.617.617a.645.645,0,0,1-.456,1.1Z",
    transform: "translate(-187.266 -260.39)",
    fill: "#82aee3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55591",
    "data-name": "Path 55591",
    d: "M147.36,337.259a.642.642,0,0,1-.456-.189l-1.486-1.486a.644.644,0,1,1,.911-.911l1.486,1.485a.645.645,0,0,1-.456,1.1Z",
    transform: "translate(-132.75 -305.74)",
    fill: "#0290cf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48230",
    "data-name": "Group 48230",
    transform: "translate(13.105 2.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48229",
    "data-name": "Group 48229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48228",
    "data-name": "Group 48228"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2836",
    "data-name": "Ellipse 2836",
    cx: 0.645,
    cy: 0.645,
    r: 0.645,
    fill: "#0573ce"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeApplying);
export default __webpack_public_path__ + "static/media/home-applying.a93661d341973313ea148265b3ec6af7.svg";
export { ForwardRef as ReactComponent };